/**
 * Centralized logging utility.
 * - Development: forwards to console.
 * - Production: log/info/debug/warn are no-op; errors still forwarded to console
 *   (wire up Sentry or another reporting tool in integrations/sentry if desired).
 */

const isDev = import.meta.env.DEV;

function noop() {}

export const logger = {
  log: isDev ? (...args: unknown[]) => console.log(...args) : noop,
  info: isDev ? (...args: unknown[]) => console.info(...args) : noop,
  debug: isDev ? (...args: unknown[]) => console.debug(...args) : noop,
  warn: isDev ? (...args: unknown[]) => console.warn(...args) : noop,
  error: (...args: unknown[]) => console.error(...args),
};
